import { debounce, isPlainObject, compact, isEmpty, isString, flatten, uniqBy } from 'lodash'
import { exportXlsFromMultiselect } from '../../utils'
import moment from 'moment'

export default {
  data () {
    return {
      program: null,
      programsFilter: [],
      promoteur: null,
      promoteursFilter: [],
      actability: false,
      // locked: null,
      displayTopButtom: false,
      profitability: 0,
      lotType: [],
      stateFilter: [],
      programsFilters: [],
      taxDispositifsFilter: [],
      promoteurs: [],
      annexType: [],
      exposures: [],
      livraison: [],
      nature: [],
      floors: [],
      createdDate: null,
      exportXlsFromMultiselect,
      lotsStatus: ['available', 'optioned'],
      programStatus: ['available'],
      typeArray: [{label: '1', value: 1}, {label: '2', value: 2}, {label: '3', value: 3}, {label: '4', value: 4}, {label: '5', value: 5}, {label: '6+', value: 6}],
      filters: {
        status: ['available', 'optioned'],
        lots__status: ['available', 'optioned'],
        program_status: ['available'],
        lot_type: [],
        promoteurs: [],
        floor: [],
        lots__floor: [],
        tax_dispositifs: [],
        lots__tax_dispositifs: [],
        lots__exposures: [],
        exposures: [],
        from_flux: undefined,
        diffusion_enabled: undefined
      },
      initFilters: {
        status: ['available', 'optioned'],
        lots__status: ['available', 'optioned'],
        program_status: ['available'],
        lot_type: [],
        state: [],
        floor: [],
        lots__floor: [],
        tax_dispositifs: [],
        lots__tax_dispositifs: [],
        lots__exposures: [],
        exposures: [],
        from_flux: undefined,
        diffusion_enabled: undefined
      },
      min: {
        rent: 0,
        profitability: 0,
        surface: 0,
        price: 0,
        dateActabilite: 20171,
        type: 1
      },
      max: {
        rent: 1500,
        profitability: 10,
        surface: 100,
        price: {
          EUR: 400000,
          MAD: 4000000
        },
        dateActabilite: 20224,
        type: 6
      },
      sortButtons: {
        label: 'Trier les programmes par :',
        buttons: [
          {
            key: 'name',
            sort: 'asc',
            label: 'Nom de A à Z'
          },
          {
            key: 'name',
            sort: 'desc',
            label: 'Nom de Z à A'
          },
          {
            key: 'created_on',
            sort: 'desc',
            label: 'Date de création la plus récente',
            needProfile: ['admin', 'editor']
          },
          {
            key: 'created_on',
            sort: 'asc',
            label: 'Date de création la plus ancienne',
            needProfile: ['admin', 'editor']
          }
        ]
      }
    }
  },
  computed: {
    nextPage () {
      if (this.$route.name === 'StockLots') {
        if (this.currentPage && this.totalPage && this.totalPage > this.currentPage) {
          return this.currentPage + 1
        }
      } else if (this.$route.name === 'StockPrograms') {
        if (this.currentProgramPage && this.totalProgramPage && this.totalProgramPage > this.currentProgramPage) {
          return this.currentProgramPage + 1
        }
      } else return 1
    },
    paramsList () {
      if (this.$route.name === 'StockLots') {
        return {
          loading: this.bigLoading,
          totalPage: this.totalPage,
          sortBy: this.sortBy,
          currentPage: this.currentPage,
          hasFilter: this.hasFilter,
          nextPage: this.nextPage,
          infiniteLoading: this.infiniteLoading
        }
      }
      if (this.$route.name === 'StockPrograms') {
        return {
          totalPage: this.totalProgramPage,
          sortBy: this.sortBy,
          currentPage: this.currentProgramPage,
          hasFilter: this.hasFilter,
          nextPage: this.nextPage,
          infiniteLoading: this.infiniteLoading
        }
      }
    },
    perPageProgram () {
      if (this.programPanel === 'CARDS') return 20
      else return 50
    },
    profilAvailableStatus () {
      let status = []
      if (this.isAdmin) {
        status.push(this.statusData.draft)
      }
      status.push(this.statusData.available)
      status.push(this.statusData.optioned)
      if (this.isAdmin) {
        status.push(this.statusData.reserved)
        status.push(this.statusData.sold)
      }
      return status
    },
    currentSortButtons () {
      if (this.$route.name === 'StockPrograms') return this.sortButtons
      else return {}
    },
    filteredTrimestrialsChoices () {
      if (this.filters.date_livraison__gte) {
        return this.trimestrialsChoices.filter(x => {
          return x[0] >= this.filters.date_livraison__gte
        })
      } else return this.trimestrialsChoices
    },
    filtersSelected () {
      return (this.filters.lots__profitability__gte && this.filters.lots__profitability__gte !== 0) ||
            (this.filters.rent__gte && this.filters.rent__gte !== 0) ||
            (this.filters.rent__lte && this.filters.rent__lte !== 0) ||
            (this.program && !isEmpty(this.program))
    },
    criteriasSelected () {
      let nature = []
      if (this.nature && this.nature.length && Array.isArray(this.nature)) {
        nature = this.nature.filter(x => {
          return (x.value ? x.value !== 'flat' : x !== 'flat') && (x.value ? x.value !== 'house' : x !== 'house')
        })
      } else if (this.nature === 'flat' || this.nature === 'house') nature = []
      return (nature && nature.length) ||
             (this.filters.surface__gte && this.filters.surface__gte !== 0) ||
             (this.filters.surface__lte && this.filters.surface__lte !== 0) ||
             (this.floors && this.floors.length) ||
             (this.exposures && this.exposures.length) ||
             (this.annexType && this.annexType.length)
    }
  },
  watch: {
    // 'filters.promoteur' (v) {
    //   return this.updatePromoteurFilter(v)
    // },
    // 'filters.program' (v) {
    //   // return this.updateProgramFilter(v)
    //   return this.getFromQuery(this.filters.program, this.programsFilters, 'programFilter')
    // },
    // 'filters.address__state_code' (v) {
    //   return this.getFromQuery(v, this.states, 'stateFilter')
    // },
    states () {
      if (this.filters.address__state_code) {
        return this.getFromQuery(this.filters.address__state_code, this.states, 'stateFilter')
      }
    }
  },
  methods: {
    async initQueryParams () {
      if (this.$route.query.program) {
        let programs = []
        if (Array.isArray(this.$route.query.program) && this.$route.query.program.length) {
          const {data} = await this.$api.programService.get({program: this.$route.query.program})
          programs = data.items
        } else if (isString(this.$route.query.program)) {
          const {data} = await this.$api.programService.getOne(this.$route.query.program)
          programs = [data]
        }
        this.getFromQuery(this.$route.query.program, programs, 'programsFilter')
      }
      if (this.$route.query.promoteur) {
        let promoteurs = []
        if (Array.isArray(this.$route.query.promoteur) && this.$route.query.promoteur.length) {
          const {data} = await this.$api.promoteurService.get({promoteur: this.$route.query.promoteur})
          promoteurs = data.items
          console.log(data)
        } else if (isString(this.$route.query.promoteur)) {
          const {data} = await this.$api.promoteurService.getOne(this.$route.query.promoteur)
          promoteurs = [data]
        }
        this.getFromQuery(this.$route.query.promoteur, promoteurs, 'promoteursFilter')
      }
      if (this.$route.query.address__state_code) {
        this.getFromQuery(this.$route.query.address__state_code, this.states, 'stateFilter')
      }
      if (this.$route.query.lots__floor) {
        let lotsFloor = Array.isArray(this.$route.query.lots__floor)
                        ? this.$route.query.lots__floor.map(x => x.split(' ').join('+'))
                        : this.$route.query.lots__floor.split(' ').join('+')
        this.getFromQuery(lotsFloor, this.floorsList, 'floors')
      }
      if (this.$route.query.lots__exposures) {
        this.getFromQuery(this.$route.query.lots__exposures, this.exposureList, 'exposures')
      }
      if (this.$route.query.annexes__annex_type) {
        this.getFromQuery(this.$route.query.annexes__annex_type, this.annexesList, 'annexType')
      }
      if (this.$route.query.nature || this.$route.query.lots__nature) {
        let query = this.$route.query.nature || this.$route.query.lots__nature
        if (Array.isArray(query)) {
          this.nature = query
        } else {
          this.nature = [query]
        }
        // console.log(query)
        // this.getFromQuery(query, this.naturesList, 'nature')
      }
      if (this.$route.query.tax_dispositifs) {
        this.getFromQuery(this.$route.query.tax_dispositifs, this.taxDispositifsList, 'taxDispositifsFilter')
      }
      if (this.$route.query.profitability__gte || this.$route.query.lots__profitability__gte) {
        this.profitability = this.$route.query.profitability__gte || this.$route.query.lots__profitability__gte
      }
      // if (this.$route.query.locked) {
      //   this.locked = true
      // }
      if (this.$route.query.date_actabilite__lt) this.actability = true
      if (this.$route.query.date_livraison && this.trimestrialsChoicesByYearObj && this.trimestrialsChoicesByYearObj.length) {
        let data = []
        this.$route.query.date_livraison.forEach(x => {
          data.push(this.trimestrialsChoicesByYearObj.find(y => {
            return y.value.includes(String(x))
          }))
        })
        if (compact(data).length) this.livraison = uniqBy(compact(data), x => x.label)
      }
      if (this.$route.query.lot_type) {
        if (!Array.isArray(this.$route.query.lot_type)) this.$route.query.lot_type = [this.$route.query.lot_type]
        let type = this.$route.query.lot_type.map(t => {
          return t.split('').find(x => x.match(/\d/))
        })
        this.lotType = [type[0], type[type.length - 1]]
      }
      if (this.isAdmin) {
        if (localStorage.getItem('stock_filter_lots__status')) {
          this.updateLotStatusFilter(JSON.parse(localStorage.getItem('stock_filter_lots__status')))
        }
        if (localStorage.getItem('stock_filter_program_status')) {
          this.updateProgramStatusFilter(JSON.parse(localStorage.getItem('stock_filter_program_status')))
        }
      }
      if (this.$route.query.lots__status || this.$route.query.status) {
        let query = this.$route.query.lots__status || this.$route.query.status
        if (!Array.isArray(query)) query = [query]
        this.updateLotStatusFilter(query)
      }
      if (this.$route.query.program_status) {
        let query = this.$route.query.program_status
        if (!Array.isArray(query)) query = [query]
        this.updateProgramStatusFilter(query)
      }
      if (this.$route.query.sale_price__gte || this.$route.query.sale_price__lte) {
        this.updatePriceFilter([this.$route.query.sale_price__gte, this.$route.query.sale_price__lte])
      }
      if (this.$route.query.lots__sale_price__gte || this.$route.query.lots__sale_price__lte) {
        this.updatePriceFilter([this.$route.query.lots__sale_price__gte, this.$route.query.lots__sale_price__lte])
      }
    },
    afterChange () {
      this.submit()
    },
    getProgramsFilters: debounce(function (query = null) {
      this.loadingFindPrograms = true
      this.$api.programService.get({name: query}).then(r => {
        this.loadingFindPrograms = false
        this.programsFilters = r.data.items
      })
    }, 600),
    getPromoteurs: debounce(function (query) {
      this.$api.promoteurService.get({name: query}).then(r => {
        this.promoteurs = r.data.items
      })
    }, 600),
    beforeGet () {
      // if (this.filters.program && typeof this.filters.program === 'object') {
      //   this.filters.program = this.filters.program.pk
      // }
      // if (this.filters.promoteur && typeof this.filters.promoteur === 'object') {
      //   this.filters.promoteur = this.filters.promoteur.pk
      // }
    },
    resetAllFilters () {
      this.program = null
      this.promoteur = null
      this.programsFilter = []
      this.promoteursFilter = []
      this.profitability = null
      this.createdDate = null
      this.actability = null
      this.lotType = []
      this.livraison = []
      this.stateFilter = []
      this.taxDispositifsFilter = []
      this.annexType = []
      this.exposures = []
      this.nature = []
      this.floors = []
      this.lotsStatus = this.initFilters.lots__status
      this.programStatus = this.initFilters.program_status
      this.$store.commit('setScrollEl', null)

      this.query = Object.assign({}, this.initFilters)
      this.filters = Object.assign({}, this.initFilters)
      if (this.isAdmin) {
        if (localStorage.getItem('stock_filter_lots__status')) {
          this.updateLotStatusFilter(JSON.parse(localStorage.getItem('stock_filter_lots__status')))
        }
        if (localStorage.getItem('stock_filter_program_status')) {
          this.updateProgramStatusFilter(JSON.parse(localStorage.getItem('stock_filter_program_status')))
        }
      }
      this.$nextTick(async () => {
        this.submit()
      })
    },
    getFromQuery (query, values, model) {
      console.log('getFromQuery')
      console.log(values)
      let filter = values.map(x => {
        if (Array.isArray(query)) {
          if (query.includes(x.value || x.code || x.pk)) return x
        } else if (isPlainObject(query) || isString(query)) {
          if ([x.value, x.code, x.pk].includes(query)) return x
        }
      })
      this[model] = compact(filter)
      console.log(this[model])
    },
    deleteItemInArr (arr, idx, multiple) {
      if (multiple) {
        arr.forEach(x => {
          if (!Array.isArray(x)) x = null
          else x.splice(idx, 1)
        })
      } else arr.splice(idx, 1)
      this.$nextTick(() => {
        this.submit()
      })
    },
    changeProgramPanel (val) {
      this.programPanel = val
      this.filters.tab = val
      this.saveHistory(this.filters)
      this.getPrograms(this.filters)
    },
    handleScroll (e) {
      if (['StockPrograms', 'StockLots', 'StockMap'].includes(this.$route.name)) {
        // Stock info in sticky
        let divScrollTop = document.querySelector('#columns-collapse') ? document.querySelector('#columns-collapse').offsetTop : null
        let filterInfo = document.querySelector('#filter-info') ? document.querySelector('#filter-info').getBoundingClientRect() : null
        if (!this.opened && filterInfo) {
          if (divScrollTop > filterInfo.bottom) this.displayTopButtom = true
          else this.displayTopButtom = false
        }
      }
    },
    updateFilters (filters) {
      this.filters = filters
      this.$nextTick(() => {
        this.submit()
      })
    },
    updateStateFilter (e) {
      if (Array.isArray(e)) this.$set(this.filters, 'address__state_code', e.map(x => x.code || x))
      else if (isPlainObject(e)) this.$set(this.filters, 'address__state_code', e.code)
      else this.$set(this.filters, 'address__state_code', [e])
      this.$nextTick(() => {
        this.submit()
      })
    },
    deleteStateFilter: debounce(function (i) {
      if (Array.isArray(this.filters.address__state_code)) this.filters.address__state_code.splice(i, 1)
      else this.$set(this.filters, 'address__state_code', [])
      this.stateFilter.splice(i, 1)
      this.$nextTick(() => {
        this.submit()
      })
    }, 200),
    updatePromoteurFilter (e) {
      if (Array.isArray(e)) this.$set(this.filters, 'promoteur', e.map(x => x.pk || x))
      else if (isPlainObject(e)) this.$set(this.filters, 'promoteur', e.pk)
      else this.$set(this.filters, 'promoteur', [e])
      // this.$set(this.filters, 'promoteur', e)
      this.$nextTick(() => {
        this.submit()
      })
    },
    deletePromoteurFilter: debounce(function (i) {
      if (Array.isArray(this.filters.promoteur)) this.filters.promoteur.splice(i, 1)
      else this.$set(this.filters, 'promoteur', [])
      this.promoteursFilter.splice(i, 1)
      this.$nextTick(() => {
        this.submit()
      })
    }, 200),
    updateLotStatusFilter (e) {
      this.$set(this.filters, 'lots__status', e)
      this.$set(this.filters, 'status', e)
      this.$set(this, 'lotsStatus', e)
      if (this.isAdmin) {
        localStorage.setItem('stock_filter_lots__status', JSON.stringify(e))
        this.initFilters.lots__status = e
        this.initFilters.status = e
      }
      this.$nextTick(() => {
        this.submit()
      })
    },
    updateProgramStatusFilter (e) {
      this.$set(this.filters, 'program_status', e)
      this.$set(this, 'programStatus', e)
      if (this.isAdmin) {
        localStorage.setItem('stock_filter_program_status', JSON.stringify(e))
        this.initFilters.program_status = e
      }
      this.$nextTick(() => {
        this.submit()
      })
    },
    updateFluxFilter (e) {
      this.$set(this.filters, 'from_flux', e)
      this.$nextTick(() => {
        this.submit()
      })
    },
    updateDiffusionFilter (e) {
      this.$set(this.filters, 'diffusion_enabled', e)
      this.$nextTick(() => {
        this.submit()
      })
    },
    updateActabilityFilter: debounce(function (e) {
      e = !e
      if (e) {
        let trim = [[0, 1, 2], [3, 4, 5], [6, 7, 8], [9, 10, 11]]
        let date = new Date()
        let currentTrim = trim.findIndex(x => x.includes(date.getMonth())) + 1
        this.$set(this.filters, 'date_actabilite__lt', `${date.getFullYear()}${currentTrim}`)
        this.$set(this.filters, 'date_actabilite__gt', 0)
        this.actability = true
        this.$nextTick(() => {
          this.submit()
        })
      } else {
        this.$set(this.filters, 'date_actabilite__lt', null)
        this.$set(this.filters, 'date_actabilite__gt', null)
        this.actability = false
        this.$nextTick(() => {
          this.submit()
        })
      }
      this.fixFocus('#actability-filter')
    }, 200),
    updateNatureFilter (e, el) {
      console.log(e, el)
      this.$set(this.filters, 'nature', e)
      this.$set(this.filters, 'lots__nature', e)
      this.$nextTick(() => {
        this.submit()
        this.fixFocus(el)
      })
    },
    deleteNatureFilter: debounce(function (i) {
      this.nature.splice(i, 1)
      // this.filters.nature.splice(idx, 1)
      // this.filters.lots__nature.splice(idx, 1)
      this.$nextTick(() => {
        this.submit()
      })
    }, 200),
    fixFocus (element) {
      // Debug focus persistant sur les cases à cocher (app/Maison) avec chrome
      document.querySelector(element).blur()
    },
    mainUpdateFilters (filter, val) {
      if (Array.isArray(val)) {
        this.$set(this.filters, filter, val.map(x => x.value || x))
      } else if (isPlainObject(val)) {
        this.$set(this.filters, filter, val.value)
      } else {
        this.$set(this.filters, filter, [val])
      }
    },
    updateAnnexesFilter (e) {
      if (!Array.isArray(e)) e = [e]
      let annexValues = e.map(x => x.value)
      if (annexValues.includes('parking') && !annexValues.includes('parking_ext') && !annexValues.includes('parking_int')) {
        e.push({label: 'Parking Ext.', value: 'parking_ext'})
        e.push({label: 'Parking Int.', value: 'parking_int'})
      }
      this.mainUpdateFilters('annexes__annex_type', e)
      this.mainUpdateFilters('lots__annexes__annex_type', e)
      this.$set(this, 'annexType', e)
      this.$nextTick(() => {
        this.submit()
      })
    },
    deleteAnnexesFilter: debounce(function (i) {
      console.log(this.filters.annexes__annex_type)
      console.log(this.filters.lots__annexes__annex_type)
      console.log(this.filters)
      if (Array.isArray(this.filters.annexes__annex_type)) {
        this.filters.annexes__annex_type.splice(i, 1)
        this.filters.lots__annexes__annex_type.splice(i, 1)
        this.annexType.splice(i, 1)
      } else {
        this.$set(this.filters, 'annexes__annex_type', [])
        this.$set(this.filters, 'lots__annexes__annex_type', [])
        this.$set(this, 'annexType', [])
      }
      this.$nextTick(() => {
        this.submit()
      })
    }, 200),
    deleteSurfaceGtFilter: debounce(function () {
      this.filters.surface__gte = null
      this.filters.lots__surface__gte = null
      this.$nextTick(() => {
        this.submit()
      })
    }, 200),
    deleteSurfaceLtFilter: debounce(function () {
      this.filters.surface__lte = null
      this.filters.lots__surface__lte = null
      this.$nextTick(() => {
        this.submit()
      })
    }, 200),
    deleteSaleGtFilter: debounce(function () {
      this.filters.sale_price__gte = null
      this.filters.lots__sale_price__gte = null
      this.$nextTick(() => {
        this.submit()
      })
    }, 200),
    deleteSaleLtFilter: debounce(function () {
      this.filters.sale_price__lte = null
      this.filters.lots__sale_price__lte = null
      this.$nextTick(() => {
        this.submit()
      })
    }, 200),
    updateFloorFilter (e) {
      this.mainUpdateFilters('lots__floor', e)
      this.mainUpdateFilters('floor', e)
      this.$set(this, 'floors', e)
      this.$nextTick(() => {
        this.submit()
      })
    },
    deleteFloorFilter: debounce(function (i) {
      this.filters.lots__floor.splice(i, 1)
      this.filters.floor.splice(i, 1)
      this.floors.splice(i, 1)
      this.$nextTick(() => {
        this.submit()
      })
    }, 200),
    updateExposureFilter (e) {
      this.mainUpdateFilters('lots__exposures', e)
      this.mainUpdateFilters('exposures', e)
      this.$set(this, 'exposures', e)
      this.$nextTick(() => {
        this.submit()
      })
    },
    deleteExposureFilter: debounce(function (i) {
      this.filters.lots__exposures.splice(i, 1)
      this.filters.exposures.splice(i, 1)
      this.exposures.splice(i, 1)
      this.$nextTick(() => {
        this.submit()
      })
    }, 200),
    dispositifName (val) {
      if (val) {
        return val.short_label || val.label
      }
    },
    deleteDispositifsFilter: debounce(function (i) {
      this.filters.tax_dispositifs.splice(i, 1)
      this.filters.lots__tax_dispositifs.splice(i, 1)
      this.taxDispositifsFilter.splice(i, 1)
      this.$nextTick(() => {
        this.submit()
      })
    }, 200),
    updateDispositifsFilter (e) {
      this.mainUpdateFilters('tax_dispositifs', e)
      this.mainUpdateFilters('lots__tax_dispositifs', e)
      this.$nextTick(() => {
        this.submit()
      })
    },
    // updateLockedFilter (e) {
    //   this.$set(this.filters, 'locked', e)
    //   this.$nextTick(() => {
    //     this.submit()
    //   })
    // },
    updateLivraisonFilter (e) {
      this.$set(this.filters, 'date_livraison', flatten(compact(e.map(x => x.value))))
      let data = []
      this.filters.date_livraison.forEach(x => {
        data.push(this.trimestrialsChoicesByYearObj.find(y => {
          return y.value.includes(String(x))
        }))
      })
      if (compact(data).length) this.livraison = uniqBy(compact(data), x => x.label)
      this.$nextTick(() => {
        this.submit()
      })
    },
    deleteLivraisonFilter: debounce(function (l) {
      let idxFilter
      let idx
      let livraisonFilterEnd = this.filters.date_livraison
      idx = this.livraison.findIndex(x => x.label === l.label)
      this.livraison.splice(idx, 1)
      l.value.forEach(res => {
        idxFilter = this.filters.date_livraison.findIndex(x => x === res)
        livraisonFilterEnd.splice(idxFilter, 1)
      })
      this.$set(this.filters, 'date_livraison', livraisonFilterEnd)
      if (this.filters.date_livraison.length === 0) {
        delete this.filters.date_livraison
      }
      this.$nextTick(() => {
        this.submit()
      })
    }, 200),
    updateProgramFilter: debounce(function (e) {
      if (this.loadingFindPrograms) return
      if (Array.isArray(e)) this.$set(this.filters, 'program', e.map(x => x.pk || x))
      else if (isPlainObject(e)) this.$set(this.filters, 'program', e.pk)
      else this.$set(this.filters, 'program', [e])
      // this.$set(this.filters, 'program', e)
      this.$nextTick(() => {
        this.submit()
      })
    }, 600),
    deleteProgramFilter: debounce(function (i) {
      if (Array.isArray(this.filters.program)) this.filters.program.splice(i, 1)
      else this.$set(this.filters, 'program', [])
      this.programsFilter.splice(i, 1)
      this.$nextTick(() => {
        this.submit()
      })
    }, 200),
    updateLotTypeFilter: debounce(function (e) {
      let tmp = []
      if (e[0] !== this.min.type || e[1] !== this.max.type) {
        for (let i = e[0]; i <= e[1]; i++) {
          tmp.push(`T${i}`)
          tmp.push(`T${i}_bis`)
          tmp.push(`T${i}_duplex`)
        }
      }
      this.$set(this.filters, 'lot_type', tmp)
      this.$set(this.filters, 'lots__lot_type', tmp)
      let type = tmp.map(t => {
        return t.split('').find(x => x.match(/\d/))
      })
      this.lotType = [type[0], type[type.length - 1]]
      this.$nextTick(() => {
        this.submit(this.filters, 0)
      })
    }, 200),
    deleteLotTypeFilter: debounce(function () {
      this.$set(this.filters, 'lot_type', [])
      this.$set(this.filters, 'lots__lot_type', [])
      this.$set(this, 'lotType', [])
      this.$nextTick(() => {
        this.submit(this.filters, 0)
      })
    }, 200),
    updateSurfaceFilter: debounce(function (e) {
      if (e[0] !== this.filters.surface__gte || e[1] !== this.filters.surface__lte) {
        if (e[0] === this.min.surface) {
          this.$set(this.filters, 'surface__gte', null)
          this.$set(this.filters, 'lots__surface__gte', null)
        } else {
          this.$set(this.filters, 'surface__gte', e[0])
          this.$set(this.filters, 'lots__surface__gte', e[0])
        }
        if (e[1] === this.max.surface) {
          this.$set(this.filters, 'surface__lte', null)
          this.$set(this.filters, 'lots__surface__lte', null)
        } else {
          this.$set(this.filters, 'surface__lte', e[1])
          this.$set(this.filters, 'lots__surface__lte', e[1])
        }
        this.$nextTick(() => {
          this.submit(this.filters, 0)
        })
      }
    }, 200),
    updatePriceFilter: debounce(function (e) {
      if (e[0] !== this.filters.sale_price__gte || e[1] !== this.filters.sale_price__lte) {
        if (e[0] === this.min.price[this.currency]) {
          this.$set(this.filters, 'sale_price__gte', null)
          this.$set(this.filters, 'lots__sale_price__gte', null)
        } else {
          this.$set(this.filters, 'sale_price__gte', e[0])
          this.$set(this.filters, 'lots__sale_price__gte', e[0])
        }
        if (e[1] === this.max.price[this.currency]) {
          this.$set(this.filters, 'sale_price__lte', null)
          this.$set(this.filters, 'lots__sale_price__lte', null)
        } else {
          this.$set(this.filters, 'sale_price__lte', e[1])
          this.$set(this.filters, 'lots__sale_price__lte', e[1])
        }
        this.$nextTick(() => {
          this.submit(this.filters, 0)
        })
      }
    }, 200),
    updateRentFilter: debounce(function (e) {
      if (e[0] !== this.filters.rent__gte || e[1] !== this.filters.rent__lte) {
        if (e[0] === this.min.rent) {
          this.$set(this.filters, 'rent__gte', null)
          this.$set(this.filters, 'lots__rent__gte', null)
        } else {
          this.$set(this.filters, 'rent__gte', e[0])
          this.$set(this.filters, 'lots__rent__gte', e[0])
        }
        if (e[1] === this.max.rent) {
          this.$set(this.filters, 'rent__lte', null)
          this.$set(this.filters, 'lots__rent__lte', null)
        } else {
          this.$set(this.filters, 'rent__lte', e[1])
          this.$set(this.filters, 'lots__rent__lte', e[1])
        }
        this.$nextTick(() => {
          this.submit(this.filters, 0)
        })
      }
    }, 200),
    updateRemuneration (val, plus) {
      let newVal = Number.parseFloat(val)
      if (plus) {
        if (newVal >= this.max.profitability) return
        newVal += 0.1
      } else newVal -= 0.1
      newVal = Number(newVal.toFixed(1))
      this.$set(this, 'profitability', newVal)
      this.updateRemunerationFilter(newVal)
    },
    updateRemunerationFilter: debounce(function (e) {
      if (e !== this.filters.profitability__gte || e !== this.filters.lots__profitability__gte) {
        if (e === this.min.profitability) {
          this.$set(this.filters, 'profitability__gte', null)
          this.$set(this.filters, 'lots__profitability__gte', null)
          this.$set(this, 'profitability', null)
        } else if (e >= this.max.profitability) {
          this.$set(this.filters, 'profitability__gte', this.max.profitability)
          this.$set(this.filters, 'lots__profitability__gte', this.max.profitability)
          this.$set(this, 'profitability', this.max.profitability)
        } else {
          this.$set(this.filters, 'profitability__gte', e)
          this.$set(this.filters, 'lots__profitability__gte', e)
        }
        this.$nextTick(() => {
          this.submit(this.filters, 0)
        })
      }
    }, 200),
    updateCreatedDateFilter: debounce(function (e) {
      if (e[0] && e[1] && (e[0] !== this.filters.created_on__gte || e[1] !== this.filters.created_on__lte)) {
        this.$set(this.filters, 'created_on__gte', moment(e[0]).format('DD/MM/YYYY'))
        this.$set(this.filters, 'created_on__lte', moment(e[1]).format('DD/MM/YYYY'))
        this.$nextTick(() => {
          this.submit(this.filters, 0)
        })
      }
    }, 600)
  }
}



// WEBPACK FOOTER //
// ./src/components/stock/StockFiltersMixin.js